import { TextareaAutosize, IconButton } from "@mui/material";
import { swalError, swalSuccess } from "@unisearch/helpers";
import React, { useState } from "react";
import { MdSend } from "react-icons/md";
import API from "@unisearch/helpers/api";
import styles from "./comment_text_box.module.scss";

export const CommentTextBox = ({
  postSlug,
  parentId,
  loadComment,
  commentType,
}) => {
  const [content, setContent] = useState();

  const handleSubmit = async () => {
    let payload = {
      parentId: parentId,
      commentType: commentType,
      referenceSlug: postSlug,
      content: content,
    };

    if (content && content != "") {
      await API.post("/public/forum-comment", payload).then((res) => {
        if (!res.error) {
          setContent("");

          if (loadComment) loadComment();

          if (!res.error) {
            swalSuccess("We have received your comment successfully", "Thanks");
          } else {
            swalError("Sorry, Something wrong happened");
          }
        }
      });
    }
  };
  return (
    <div className={styles.comment_box_wrapper}>
      <TextareaAutosize
        minRows={1}
        placeholder="Any Question?"
        style={{
          border: "none",
          resize: "none",
          fontWeight: "500",
        }}
        onChange={(e) => {
          setContent(e.target.value);
        }}
        value={content}
      />
      <IconButton onClick={handleSubmit} disableRipple={true}>
        <MdSend />
      </IconButton>
    </div>
  );
};

export default CommentTextBox;
